import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { AppState } from "../../reducers";
import { DisplayReportJob } from "../../models/ui";
import { MessageActions, ReportingActions } from "../../actions";
import { ReportingApi } from "../../services/webservice/reporting-api.service";
import { REPORTTYPES } from "../../models/ui/reporting.ui-model";
import { ReportJob } from "../../models";

@Injectable()
export class ReportJobService {

	static createDisplayReportJob(reportJob: ReportJob, title: string, subtitle: string, filename: string, reportType: string) {
		let displayReportJob = new DisplayReportJob();
		displayReportJob.reportJob = reportJob;
		displayReportJob.status = 'LOADING';
		displayReportJob.title = title;
		displayReportJob.subtitle = subtitle;
		displayReportJob.filename = filename;
		displayReportJob.reportType = reportType;
		return displayReportJob;
	}

	constructor(
		private store: Store<AppState>,
		private reportingActions: ReportingActions,
		private messageActions: MessageActions,
		private reportingApi: ReportingApi
	) {
	}

	queueReportJob(isBookingOffice: boolean, reportType: string , filename: string, queryString: string, reportSubtitle?: string) {
		this.reportingApi.queueReportJob(isBookingOffice, reportType, filename, queryString).subscribe(
			async reportJob => {
				const displayReportJob = ReportJobService.createDisplayReportJob(reportJob, REPORTTYPES[reportType], reportSubtitle, filename, reportType);
				await this.store.dispatch(this.reportingActions.setDisplayReportJob(displayReportJob));
				this.pollJobStatus(displayReportJob);
			},
			error => {
				this.handleError(error);
			}
		);
	}

	pollJobStatus(drj: DisplayReportJob): void {
		this.poll(drj).catch(error => this.handleError(error))
	}

	private async poll(drj: DisplayReportJob) {
		let hangOn: boolean = true;
		let backOff: number = 1;
		while (hangOn) {
			await new Promise(f => setTimeout(f, backOff * 1000));
			const job = await this.store.select("reporting", "reportJobs")
				.map(jobs => jobs.find(j => j.reportJob.job === drj.reportJob.job)).take(1)
				.toPromise();
			if (job == null) {
				hangOn = false;
				return;
			}
			let response: Response = await this.reportingApi.getReportJobStatus(job.reportJob.status).toPromise();
			const jobCopy = Object.assign({}, job);
			if (response.status === 201) {
				jobCopy.status = 'DONE'
				this.store.dispatch(this.reportingActions.updateDisplayReportJob(jobCopy))
			} else if (job.status === 'DONE' && response.status === 404) {
				jobCopy.status = 'INVALIDATED'
				this.store.dispatch(this.reportingActions.updateDisplayReportJob(jobCopy))
				hangOn = false;
			} else if (response.status === 404 || response.status === 502) {
				jobCopy.status = 'FAILED'
				this.store.dispatch(this.reportingActions.updateDisplayReportJob(jobCopy))
				hangOn = false;
			}

			if (backOff < 5) {
				backOff = 5
			} else if (backOff < 15) {
				backOff += 5
			}
		}
	}

	private handleError(error: any) {
		if (!error.messageDe) {
			error.messageDe = "Es ist ein unerwarteter Fehler bei der Verarbeitung des Berichts aufgetreten.";
		}
		this.store.dispatch(this.messageActions.displayMessage(error.messageDe, "error"));
	}

}



// WEBPACK FOOTER //
// ./src/app/ui-helper/download-status/report-job.service.ts